<template>
    <div class="com-codics-ui-btn-body iconfont" :style="{
        'height': height == null ? (size == 'normal' ? '40px' : (size == 'small' ? '30px' : '20px')) : height,
        'width': width,
        'line-height': height == null ? (size == 'normal' ? '40px' : (size == 'small' ? '30px' : '20px')) : height,
        'background': 'var(--com-codics-ui-btn-bg' + typeData[type] + '-color)',
        'color': 'var(--com-codics-ui-btn-font' + typeData[type] + '-color)',
        'border': '1px solid var(--com-codics-ui-btn-l' + typeData[type] + '-color)',
        '--hoverBgColor': 'var(--com-codics-ui-btn-hover-bg' + typeData[type] + '-color)',
        '--hoverFontColor': 'var(--com-codics-ui-btn-hover-font' + typeData[type] + '-color)',
    }
        ">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        height: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: 'normal'
        },
        type: {
            type: String,
            default: 'primary'
        },
        width: {
            type: String,
            default: 'fit-content'
        },
    },
    data() {
        return {
            typeData: {
                primary: '',
                danger: '-danger',
                warning: '-warning',
                success: '-success',
                info: '-info'
            }
        }
    }
}
</script>

<style>
:root {
    --com-codics-ui-btn-bg-color: #FBFBFB;
    --com-codics-ui-btn-bg-danger-color: #FBFBFB;
    --com-codics-ui-btn-bg-warning-color: #FBFBFB;
    --com-codics-ui-btn-bg-success-color: #FBFBFB;
    --com-codics-ui-btn-bg-info-color: #FBFBFB;
    --com-codics-ui-btn-font-color: #333;
    --com-codics-ui-btn-font-danger-color: #333;
    --com-codics-ui-btn-font-warning-color: #333;
    --com-codics-ui-btn-font-success-color: #333;
    --com-codics-ui-btn-font-info-color: #333;
    --com-codics-ui-btn-l-color: #EEE;
    --com-codics-ui-btn-l-danger-color: #333;
    --com-codics-ui-btn-l-warning-color: #333;
    --com-codics-ui-btn-l-success-color: #333;
    --com-codics-ui-btn-l-info-color: #333;
    --com-codics-ui-btn-hover-bg-color: #333;
    --com-codics-ui-btn-hover-bg-danger-color: #333;
    --com-codics-ui-btn-hover-bg-warning-color: #333;
    --com-codics-ui-btn-hover-bg-success-color: #333;
    --com-codics-ui-btn-hover-bg-info-color: #333;
    --com-codics-ui-btn-hover-font-color: #FFF;
    --com-codics-ui-btn-hover-font-danger-color: #333;
    --com-codics-ui-btn-hover-font-warning-color: #333;
    --com-codics-ui-btn-hover-font-success-color: #333;
    --com-codics-ui-btn-hover-font-info-color: #333;
}

:root[data-theme="dark"] {
    --com-codics-ui-btn-bg-color: #333;
    --com-codics-ui-btn-bg-danger-color: #FBFBFB;
    --com-codics-ui-btn-bg-warning-color: #FBFBFB;
    --com-codics-ui-btn-bg-success-color: #FBFBFB;
    --com-codics-ui-btn-bg-info-color: #FBFBFB;
    --com-codics-ui-btn-font-color: #FFF;
    --com-codics-ui-btn-font-danger-color: #333;
    --com-codics-ui-btn-font-warning-color: #333;
    --com-codics-ui-btn-font-success-color: #333;
    --com-codics-ui-btn-font-info-color: #333;
    --com-codics-ui-btn-l-color: #444;
    --com-codics-ui-btn-l-danger-color: #333;
    --com-codics-ui-btn-l-warning-color: #333;
    --com-codics-ui-btn-l-success-color: #333;
    --com-codics-ui-btn-l-info-color: #333;
    --com-codics-ui-btn-hover-bg-color: #FFF;
    --com-codics-ui-btn-hover-bg-danger-color: #333;
    --com-codics-ui-btn-hover-bg-warning-color: #333;
    --com-codics-ui-btn-hover-bg-success-color: #333;
    --com-codics-ui-btn-hover-bg-info-color: #333;
    --com-codics-ui-btn-hover-font-color: #333;
    --com-codics-ui-btn-hover-font-danger-color: #333;
    --com-codics-ui-btn-hover-font-warning-color: #333;
    --com-codics-ui-btn-hover-font-success-color: #333;
    --com-codics-ui-btn-hover-font-info-color: #333;
}

.com-codics-ui-btn-body {
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 19px;
    background: #EEE;
    background: var(attr(data-type));
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #000;
    color: var(--com-codics-ui-btn-font-color);
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
    transition: .2s;
}

.com-codics-ui-btn-body:hover {
    background: var(--hoverBgColor) !important;
    color: var(--hoverFontColor) !important;
}
</style>